(function ($) {
  window.BulkActionToolbar = function (toolbarTrigger, toolbar, options) {
    options = jQuery.extend({ container: document, clear: "X" }, options);
    toolbarTrigger = jQuery(toolbarTrigger);
    toolbar = jQuery(toolbar);
    var container = jQuery(options.container);
    var selection = {
      records: [], // The individual records on this page that are selected
      count: 0, // The count to display
      selectAllParams: null, // When non-null indicates that a selection across the entire set of results have been made
      currentPage: null, // Server uses this to process results visible on the current page synchronously
      currentPerPage: null, // Server uses this to process results visible on the current page synchronously
    };

    var selectors = {
      selectables: "[data-behaviour~=select-record]",
      hideOnSelection: "[data-behaviour~=hide-on-bulk-selection]",
      showOnSelection: "[data-behaviour~=show-on-bulk-selection]",
      bulkSelectAllBanner: "[data-behaviour~=bulk-select-all-results-banner]",
      bulkSelectAllTrigger: "[data-behaviour~=bulk-select-all-results]",
      showRecordSelectors: "[data-behaviour~=show-selectors]",
      selectionAwareLinks: "[data-behaviour~=selection-aware-export]",
    };

    // BEHAVIOUR

    container.on("record:selected", handleRecordSelected);
    container.on("record:unselected", handleRecordUnselected);
    container.on("record:inserted", selectors.selectables, handleRecordInserted);

    toolbar.on("click", ".disabled", false);

    jQuery(document).on("bulkActionToolbar:reset", resetSelected);
    jQuery(document).on("click", selectors.bulkSelectAllTrigger, handleBulkSelectAllClicked);

    // INITIALIZE

    renderBulkSelectAll();

    // EVENT HANDLERS

    function handleRecordSelected(event, payload) {
      if (indexOfRecord(payload.recordClass, payload.recordId) === -1) {
        selection.records.push({ type: payload.recordClass, id: payload.recordId });
        bulkSelectNone();
        renderBulkSelectAll();
        renderToolbar();
        showBulkActions();
      }
    }

    function handleRecordUnselected(event, payload) {
      if (otherSelectorChecked(payload)) {
        return;
      }

      var recordIndex = indexOfRecord(payload.recordClass, payload.recordId);

      if (recordIndex > -1) {
        selection.records.splice(recordIndex, 1);
        bulkSelectNone();
        renderBulkSelectAll();
        renderToolbar();
      }
    }

    function handleRecordInserted(event) {
      var recordIndex = indexOfRecord(jQuery(this).data("recordClass"), jQuery(this).data("record-id"));

      if (recordIndex > -1) {
        jQuery(this).find(":checkbox").prop("checked", true).trigger("change");
      }
    }

    function handleBulkSelectAllClicked(event) {
      var data = jQuery(event.currentTarget).data();
      checkSelectables(true).trigger("change");
      bulkSelectAll(data.bulkSelectAllParams, data.bulkSelectAllCount, data.currentPage, data.currentPerPage);
      renderBulkSelectAll();
      renderToolbar();
    }

    // INITIALIZE
    jQuery(container).addClass("selectable");
    hideBulkActions();

    // HELPER FUNCTIONS

    function bulkSelectAll(params, count, currentPage, currentPerPage) {
      selection.count = count;
      selection.selectAllParams = params;
      selection.currentPage = currentPage;
      selection.currentPerPage = currentPerPage;
    }

    function bulkSelectNone() {
      selection.count = selection.records.length;
      delete selection.selectAllParams;
      delete selection.currentPage;
      delete selection.currentPerPage;
    }

    function resetSelected(event) {
      selection.records = [];
      bulkSelectNone();
      renderToolbar();
    }

    function showBulkActions() {
      if (selection.count) {
        showRecordSelectors();
      }

      toolbarTrigger.show();
    }

    function hideBulkActions() {
      hideRecordsSelectors();
      toolbarTrigger.hide();
    }

    function renderToolbar() {
      toolbarTrigger.text(selection.count + " Selected");
      updateToolbarUrls();

      if (selection.count) {
        enableLinks();
      } else {
        disableLinks();
        hideBulkActions();
      }
    }

    function renderBulkSelectAll() {
      if (hasBulkSelectedAll()) {
        hideBulkSelectAll();
      } else if (allSelectablesChecked()) {
        showBulkSelectAll();
      } else {
        hideBulkSelectAll();
      }
    }

    function showBulkSelectAll() {
      jQuery(selectors.bulkSelectAllBanner).show();
    }

    function hideBulkSelectAll() {
      jQuery(selectors.bulkSelectAllBanner).hide();
    }

    function showRecordSelectors() {
      jQuery(selectors.showRecordSelectors).addClass("selectors-visible");
      jQuery(selectors.hideOnSelection).hide();
      jQuery(selectors.showOnSelection).css("display", "flex");
    }

    function hideRecordsSelectors() {
      selection.records = [];
      checkSelectables(false).trigger("change");
      jQuery(selectors.showRecordSelectors).removeClass("selectors-visible");
      jQuery(selectors.hideOnSelection).show();
      jQuery(selectors.showOnSelection).hide();
    }

    function updateToolbarUrls() {
      toolbar.find('input[name="bulk_count"]').val(JSON.stringify(selection.count));
      toolbar.find('input[name="bulk_scope"]').val(JSON.stringify(selection.selectAllParams));
      toolbar.find('input[name="page"]').val(JSON.stringify(selection.currentPage));
      toolbar.find('input[name="per_page"]').val(JSON.stringify(selection.currentPerPage));

      var bulkRecords = jQuery
        .map(selection.records, function (val) {
          return recordToParam(val);
        })
        .join(",");
      toolbar.find("input[name=bulk_records]").val(bulkRecords);

      updateSelectionAwareLinks(bulkRecords, selection.selectAllParams);
    }

    // Rewrites selection-aware links (e.g. the top-level Export link in the index
    // control menu) to include bulk_records / bulk_scope in their query string so
    // the modal they open — and the SavedExport it creates — carries the current
    // selection through to the CSV/JSON render. When there is no active selection
    // the href is restored to the pristine base URL, so a stale bulk_scope from a
    // prior "select all" can't leak onto the next export.
    function updateSelectionAwareLinks(bulkRecords, bulkScope) {
      var hasSelection = selection.count > 0;
      jQuery(selectors.selectionAwareLinks).each(function () {
        var link = jQuery(this);
        var baseUrl = link.data("baseUrl");

        if (!baseUrl) {
          baseUrl = link.attr("href");
          link.data("baseUrl", baseUrl);
        }

        link.attr("href", hasSelection ? appendSelectionToUrl(baseUrl, bulkRecords, bulkScope) : baseUrl);
      });
    }

    function appendSelectionToUrl(baseUrl, bulkRecords, bulkScope) {
      var parts = [];

      if (bulkRecords && bulkRecords.length) {
        parts.push("bulk_records=" + encodeURIComponent(bulkRecords));
      }

      if (bulkScope) {
        parts.push("bulk_scope=" + encodeURIComponent(JSON.stringify(bulkScope)));
      }

      if (!parts.length) {
        return baseUrl;
      }

      var joiner = baseUrl.indexOf("?") === -1 ? "?" : "&";

      return baseUrl + joiner + parts.join("&");
    }

    function checkSelectables(state) {
      return jQuery(selectors.selectables)
        .find(":checkbox")
        .filter(function () {
          return this.checked != state;
        })
        .prop("checked", state);
    }

    function allSelectablesChecked() {
      var selectables = jQuery(selectors.selectables);

      return selectables.length && selectables.find(":checkbox:checked").length == selectables.length;
    }

    function enableMenuItem(item) {
      item.removeAttribute("disabled");
    }

    function disableMenuItem(item) {
      item.setAttribute("disabled", "");
    }

    function enableLinks() {
      toolbar.find("a[href]").removeClass("disabled");
      toolbar[0]
        .querySelectorAll("sp-button[data-admin-menu-item]:not([data-disabled-menu-item])")
        .forEach(enableMenuItem);
    }

    function disableLinks() {
      toolbar.find("a[href]").addClass("disabled");
      toolbar[0].querySelectorAll("sp-button[data-admin-menu-item]").forEach(disableMenuItem);
    }

    // Several rows can key the same record (a translation grid keys each missing row by its
    // host), so the record stays selected while any other checked row still carries its key.
    function otherSelectorChecked(payload) {
      return (
        container.find(selectors.selectables).filter(function () {
          var $selector = jQuery(this);

          return (
            this !== payload.element &&
            $selector.data("record-class") === payload.recordClass &&
            $selector.data("record-id") === payload.recordId &&
            $selector.find(":checkbox").is(":checked")
          );
        }).length > 0
      );
    }

    function recordToParam(record) {
      return record.type + "-" + record.id;
    }

    function indexOfRecord(type, id) {
      for (var i = selection.records.length - 1; i > -1; i--) {
        var record = selection.records[i];

        if (record.type === type && record.id === id) {
          break;
        }
      }

      return i;
    }

    function hasBulkSelectedAll() {
      return selection.selectAllParams != null;
    }
  };
})(jQuery);
